import { Component, Input, Output, EventEmitter } from '@angular/core';
import { latestVersion, changelogData } from '../../data/changelog-data';

@Component({
  selector: 'app-system-info-modal',
  templateUrl: './system-info-modal.component.html',
})
export class SystemInfoModalComponent {
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();

  latestVersion = latestVersion;
  changelogData = changelogData;

  formatDate(date: string, tipo: 'curta' | 'completa' = 'curta'): string {
    const data = new Date(date);
    return tipo === 'completa'
      ? data.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: 'long',
          year: 'numeric',
        })
      : data.toLocaleDateString('pt-BR');
  }

  handleClose() {
    this.close.emit();
  }
}
